import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  api_url = "https://blogcreatorapi.herokuapp.com/";
  constructor(private http : HttpClient) { }

  getMessage(){
    return this.http.get(this.api_url);
  }

  createBlog(data){
    return this.http.post<any>(this.api_url + 'blog/',data);
  }

  createPost(data){
    return this.http.post<any>(this.api_url + 'blog/post/',data);
  }

  getPosts(data){
    return this.http.post<any>(this.api_url + 'blog/posts/',data);
  }


  updatePost(data){
    return this.http.put<any>(this.api_url + 'blog/post/',data)
  }


  deletePost(id){
    return this.http.delete<any>(this.api_url + 'blog/delete/'+id)
  }

  readPost(blog_url){
    return this.http.get<any>(this.api_url + 'blog/read/'+blog_url)
  }



}
